import { SVGProps, Ref, forwardRef } from 'react';

export const AZSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2H0z" fill="#0098C3" />
            <rect y={6} width={16} height={4} fill="#E00034" />
            <path d="M0 10h16v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" fill="#00AE65" />
            <path
                d="M6.32 8a1.465 1.465 0 0 0 2.553.981 1.758 1.758 0 1 1 0-1.962A1.465 1.465 0 0 0 6.32 8"
                fill="white"
            />
            <path
                d="m9.818 7.813.526.186-.526.187.24.504-.504-.239-.186.526-.187-.526-.002.001-.502.239.24-.504-.527-.186.526-.187-.24-.504.503.238.001.001.187-.526.187.526.504-.24z"
                fill="white"
            />
        </g>
    </svg>
));
AZSize16Glyph.displayName = 'AZSize16Glyph';
